import _ from 'underscore';
import React, { useEffect } from 'react';
import { OverviewWelcomeTips } from '@bingads-webui-campaign-react/overview-welcome-tips';
import { getLocalizedSupportLink } from '@bingads-webui-campaign/overview-cards-common';

import { useWelcomeTipPages } from './use-welcome-tip-pages';

type WelcomeTipsCardProps = {
  i18n: {
    getString: (key: string, params?: any) => string;
  };

  serverContext: any;
  perfMarkerUtils: {
    willFetchData: Function;
    willRender: Function;
    done: Function;
  };
  createdCampaign: boolean;
  skippedBothAtAccountCreation: boolean;
  skippedNoneAtAccountCreation: boolean;
  navigationLevel: string;
};

export const WelcomeTipsCard: React.FC<WelcomeTipsCardProps> = ({
  i18n,
  serverContext,
  perfMarkerUtils,
  createdCampaign,
  skippedBothAtAccountCreation,
  skippedNoneAtAccountCreation,
  navigationLevel,
}) => {
  const {
    isLoading, error, pages, hasPaymentPermission, showWelcomeMsg, isPaymentFirstTile, hasCoupon,
  } = useWelcomeTipPages({
    createdCampaign,
    skippedBothAtAccountCreation,
    skippedNoneAtAccountCreation,
    navigationLevel,
    perfMarkerUtils,
  });

  useEffect(() => {
    if (!isLoading) {
      perfMarkerUtils?.willRender();
      perfMarkerUtils?.done();
    }
  }, [perfMarkerUtils, isLoading]);

  return (<OverviewWelcomeTips
    isLoading={isLoading}
    pages={pages}
    hasPaymentPermission={hasPaymentPermission}
    showWelcomeMsg={showWelcomeMsg}
    isPaymentFirstTile={isPaymentFirstTile}
    hasCoupon={hasCoupon}
    name={serverContext?.CurrentUser?.FirstName || serverContext?.CurrentUser?.Name || ''}
    serverContext={serverContext}
    getLocalizedSupportLink={getLocalizedSupportLink}
    i18n={i18n}
  />);
};
